import { Switch, Route } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/not-found";
import Home from "@/pages/Home";
import Access from "@/pages/Access";
import Evaluation from "@/pages/Evaluation";
import Privacy from "@/pages/Privacy";
import MentionsLegales from "@/pages/legal/MentionsLegales";
import PrivacyPolicy from "@/pages/legal/PrivacyPolicy";
import TermsOfService from "@/pages/legal/TermsOfService";
import CookiePolicy from "@/pages/legal/CookiePolicy";
import VisionCorrection from "@/pages/specialties/VisionCorrection";
import DentalCare from "@/pages/specialties/DentalCare";
import HairRestoration from "@/pages/specialties/HairRestoration";
import AestheticMedicine from "@/pages/specialties/AestheticMedicine";
import { UxDebugOverlay } from "@/components/UxDebugOverlay";
import { NudgeBanner } from "@/components/NudgeBanner";
import { CustomCursor } from "@/components/ui/CustomCursor";
import AdminUx from "@/pages/AdminUx";

function Router() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/access" component={Access} />
      <Route path="/evaluation" component={Evaluation} />
      <Route path="/privacy" component={Privacy} />
      <Route path="/legal/mentions-legales" component={MentionsLegales} />
      <Route path="/legal/privacy-policy" component={PrivacyPolicy} />
      <Route path="/legal/terms-of-service" component={TermsOfService} />
      <Route path="/legal/cookies" component={CookiePolicy} />
      <Route path="/specialties/vision" component={VisionCorrection} />
      <Route path="/specialties/dental" component={DentalCare} />
      <Route path="/specialties/hair" component={HairRestoration} />
      <Route path="/specialties/aesthetic" component={AestheticMedicine} />
      {/* DEV-only admin dashboard — page itself guards against PROD */}
      <Route path="/admin/ux" component={AdminUx} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <CustomCursor />
        <Toaster />
        <Router />
        <NudgeBanner />
        <UxDebugOverlay />
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
